export enum RolesNames {
  GlobalDataManager = "GlobalDataManager",
  DataEnrichmentSpecialist = "DataEnrichmentSpecialist",
}
